export type OpeningHoursByDay = Record<
  number,
  Partial<Record<string, { startTime: Date; endTime: Date }>>
>;

/** Monday first, Sunday last — matches the sort used when grouping hours. */
export const WEEKDAYS_MONDAY_FIRST = [1, 2, 3, 4, 5, 6, 0] as const;

export function hasOpeningHourTimes(data: OpeningHoursByDay): boolean {
  return Object.values(data).some((hours) =>
    Object.values(hours ?? {}).some(Boolean),
  );
}
